import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Lund from './Demo/Lund/Lund';
import Intro from './Intro/Intro';
import Demo from './Demo/all/demo'
import Angelholm from './Demo/Angelholm/Angelholm'
import Kristianstad from './Demo/Kristianstad/kristianstad'
import GeneralError from './GeneralError/GeneralError'

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <GeneralError />,
  },
  {
    path: "/demo/lund",
    element: <Lund />,
  },
  {
    path: "/demo/angelholm",
    element: <Angelholm />,
  },
  {
    path: "/demo/kristianstad",
    element: <Kristianstad />,
  },
  {
    path: "/intro/:customer_name",
    element: <Intro />,
  },
  {
    path: "/demo/a/:customer_name",
    element: <Demo />,
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
